import { render, staticRenderFns } from "./MarketOpeningHoursCard.vue?vue&type=template&id=74bae59c"
import script from "./MarketOpeningHoursCard.vue?vue&type=script&lang=js"
export * from "./MarketOpeningHoursCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports